/**
 * @module GLOBAL_STYLE_PROPERTIES
 */
export const PROPERTY_FONT_SIZE = 'font-size';
export const PROPERTY_M_FONT_SIZE = 'm-font-size';
export const PROPERTY_FONT_FAMILY = 'font-family';
export const PROPERTY_FONT_STYLE = 'font-style';
export const PROPERTY_FONT_WEIGHT = 'font-weight';
export const PROPERTY_LINE_HEIGHT = 'line-height';
export const PROPERTY_COLOR = 'color';
export const PROPERTY_TEXT_DECORATION = 'text-decoration';
export const PROPERTY_TEXT_TRANSFORM = 'text-transform';
export const PROPERTY_LETTER_SPACING = 'letter-spacing';

export const PROPERTY_FONT_PRIMARY = 'primary';
export const PROPERTY_FONT_SECONDARY = 'secondary';

export const PROPERTY_PADDING_Y = 'padding-y';
export const PROPERTY_M_PADDING_Y = 'm-padding-y';
export const PROPERTY_PADDING_X = 'padding-x';
export const PROPERTY_M_PADDING_X = 'm-padding-x';
export const PROPERTY_BACKGROUND_COLOR_NULL = 'background-color-null';
export const PROPERTY_BACKGROUND_COLOR = 'background-color';
export const PROPERTY_BORDER_NULL = 'border-null';
export const PROPERTY_BORDER_WIDTH = 'border-width';
export const PROPERTY_BORDER_COLOR = 'border-color';
export const PROPERTY_BORDER_RADIUS = 'border-radius';
export const PROPERTY_M_BORDER_RADIUS = 'm-border-radius';
export const PROPERTY_BOX_SHADOW_NULL = 'box-shadow-null';
export const PROPERTY_BOX_SHADOW_SPREAD = 'box-shadow-spread';
export const PROPERTY_BOX_SHADOW_COLOR = 'box-shadow-color';
export const PROPERTY_BOX_SHADOW_BLUR = 'box-shadow-blur';
export const PROPERTY_BOX_SHADOW_X = 'box-shadow-x';
export const PROPERTY_BOX_SHADOW_Y = 'box-shadow-y';
export const PROPERTY_TRANSITION_DURATION = 'transition-duration';
export const PROPERTY_TRANSITION_TIMING_FUNCTION = 'transition-timing-function';

export const PROPERTY_PRIMARY_FONT = 'primary';
export const PROPERTY_SECONDARY_FONT = 'secondary';

/**
 * @module GLOBAL_STYLES_PROPERTY_STATES
 */
export const STATE_NORMAL = 'normal';
export const STATE_HOVER = 'hover';

/**
 * @module GLOBAL_STYLE_ELEMENTS
 */
export const TYPOGRAPHY_H1 = 'h1';
export const TYPOGRAPHY_H2 = 'h2';
export const TYPOGRAPHY_H3 = 'h3';
export const TYPOGRAPHY_H4 = 'h4';
export const TYPOGRAPHY_H5 = 'h5';
export const TYPOGRAPHY_H6 = 'h6';
export const TYPOGRAPHY_BODY_SMALL = 'body-small';
export const TYPOGRAPHY_BODY = 'body';
export const TYPOGRAPHY_BODY_LARGE = 'body-large';
export const TYPOGRAPHY_NAV_LINK = 'nav-link';

export const FONT = 'font';

export const COLORS = 'colors';

export const ELEMENT_GRID_BUTTON_PRIMARY = 'grid-button-primary';
export const ELEMENT_GRID_BUTTON_SECONDARY = 'grid-button-secondary';

export const FONT_WEIGHT_ELEMENTS = [
	TYPOGRAPHY_H1,
	TYPOGRAPHY_H2,
	TYPOGRAPHY_H3,
	TYPOGRAPHY_H4,
	TYPOGRAPHY_H5,
	TYPOGRAPHY_H6,
	TYPOGRAPHY_BODY_SMALL,
	TYPOGRAPHY_BODY,
	TYPOGRAPHY_BODY_LARGE,
	TYPOGRAPHY_NAV_LINK,
	ELEMENT_GRID_BUTTON_PRIMARY,
	ELEMENT_GRID_BUTTON_SECONDARY,
];

export const TYPOGRAPHY_HEADINGS = [
	TYPOGRAPHY_H1,
	TYPOGRAPHY_H2,
	TYPOGRAPHY_H3,
	TYPOGRAPHY_H4,
	TYPOGRAPHY_H5,
	TYPOGRAPHY_H6,
];

export const TYPOGRAPHY_PARAGRAPHS = [
	TYPOGRAPHY_BODY_SMALL,
	TYPOGRAPHY_BODY,
	TYPOGRAPHY_BODY_LARGE,
];
